function setupTilesHover() {
  const touchDevice = "ontouchstart" in document.documentElement;

  // Allow homepage blocks to have the "hover" effect on mobile
  const tiles = document.querySelectorAll('.tile');
  for (const tile of tiles) {
    tile.addEventListener('click', (e) => {
      if (!touchDevice) {
        // We are on desktop, just let the css do all the work
        return;
      }

      if (tile.classList.contains('hover')) {
        // We are on mobile, and we have shown the "back" of this tile, just let the click propagate.
        return;
      }

      // Stop propagation, so the click will not trigger
      e.preventDefault();

      // Remove all other "hovered" states
      const hoveredTiles = document.querySelectorAll('.tile.hover');
      for (const hoveredTile of hoveredTiles) {
        hoveredTile.classList.remove('hover');
      }

      // Add the "hover" class to this tile
      tile.classList.add('hover');
    });
  }
}

window.addEventListener("DOMContentLoaded", setupTilesHover);

function expandTileOnFirstVisit() {
  const localStorageKey = 'expandedTileShowed';

  if (window.localStorage.getItem(localStorageKey)) {
    return;
  }

  const expandableTile = document.querySelector('.tile[data-expand="1"]');
  const parentChildren = expandableTile.parentElement.children;
  let index = Array.prototype.slice.call(parentChildren).indexOf(expandableTile);

  if(!expandableTile || !index) {
    return;
  }

  window.localStorage.setItem(localStorageKey, true);

  // Fill up the columns before the big tile
  const colBefore = index % 4;
  if (colBefore > 0) {
    for (let i = 0; i < colBefore; i++) {
      const wrapperBefore = document.createElement('div')
      wrapperBefore.classList.add('lg:w-1/4')
      expandableTile.parentNode.insertBefore(wrapperBefore, expandableTile);

      const previous = parentChildren[index - i - 1];
      previous.classList.remove('lg:w-1/4');
      wrapperBefore.appendChild(previous);

      const next = parentChildren[index + i + 1];
      next.classList.remove('lg:w-1/4');
      wrapperBefore.appendChild(next);
    }
  }

  // Fill up the columns after the big tile
  const colAfter = 2 - (index % 4);
  if (colAfter > 0) {
    // Recalculate index
    index = Array.prototype.slice.call(parentChildren).indexOf(expandableTile);

    for (let i = 0; i < colAfter; i++) {
      const wrapperAfter = document.createElement('div');
      wrapperAfter.classList.add('lg:w-1/4');
      expandableTile.parentNode.insertBefore(wrapperAfter, expandableTile.nextElementSibling);

      const next = parentChildren[index + i + 2];
      next.classList.remove('lg:w-1/4');
      wrapperAfter.appendChild(next);

      const nextnext = parentChildren[index + i + 3];
      nextnext.classList.remove('lg:w-1/4');
      wrapperAfter.appendChild(nextnext);
    }
  }

  // Make the tile big
  expandableTile.classList.remove('hidden');
  expandableTile.classList.add('lg:w-1/2', 'h-128', 'items-center', 'justify-center');

  // Remove last row of tiles
  for (let i = 0; i < 4; i++) {
    expandableTile.parentNode.removeChild(parentChildren[parentChildren.length - 1]);
  }

  // Disable the other tiles
  const nonExpandableTiles = document.querySelectorAll('.tile[data-expand=""]');
  for (const tile of nonExpandableTiles) {
    tile.classList.add('hidden', 'lg:block');
    tile.classList.remove('tile');
    tile.removeAttribute('href');
  }

  const menuLinks = document.querySelectorAll('nav a');
  for(const menuLink of menuLinks) {
    menuLink.removeAttribute('href');
  }

}

window.addEventListener("DOMContentLoaded", expandTileOnFirstVisit);